<template>
  <ComponentCard title="Term" icon="solar:bookmark-square-minimalistic-linear">
    <div class="grid gap-2 sm:grid-cols-2">
      <BlockField :model-value="attrs.term" placeholder="The word" :read-only="readOnly" input-class="text-base font-bold text-[#1c4848]" @update:model-value="set({ term: $event })" />
      <BlockField :model-value="attrs.arabic" arabic placeholder="الكلمة" :read-only="readOnly" input-class="text-[#1c4848]" @update:model-value="set({ arabic: $event })" />
    </div>
    <BlockField :model-value="attrs.meaning" placeholder="What it means" :read-only="readOnly" input-class="text-[15px] leading-relaxed text-[#1c4848]" @update:model-value="set({ meaning: $event })" />
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
